import { c as _c } from "react/compiler-runtime";
import Check from '@mui/icons-material/Check';
import MuiSwitch, { SwitchProps } from '@mui/material/Switch';
import { styled } from '../styles';
export interface Props extends SwitchProps {}
const ThumbChecked = styled('span')(({
  theme
}) => ({
  boxShadow: theme.shadows[1],
  backgroundColor: 'currentColor',
  width: 20,
  height: 20,
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}));
const ThumbUnchecked = styled(ThumbChecked)(({
  theme
}) => ({
  backgroundColor: theme.palette.form.field.background.locked
}));
const StyledMuiSwitch = styled(MuiSwitch)(({
  theme
}) => ({
  '& .Mui-focusVisible:not(.Mui-checked) .MuiTouchRipple-root': {
    color: theme.palette.interaction.border
  }
}));
const Switch = t0 => {
  const $ = _c(6);
  let otherProps;
  if ($[0] !== t0) {
    ({
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = otherProps;
  } else {
    otherProps = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ThumbUnchecked />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ThumbChecked><Check style={{
        fontSize: "1rem"
      }} sx={{
        color: "icon.onContrasted"
      }} /></ThumbChecked>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== otherProps) {
    t3 = <StyledMuiSwitch icon={t1} checkedIcon={t2} {...otherProps} />;
    $[4] = otherProps;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default Switch;